<div
  class="widget-wrapper"
  [class.open]="!widgetCollapsed"
  [@openCloseWidget]="widgetCollapsed ? 'hide' : 'show'"
>
  <div
    class="widget-header"
    [@openCloseWidgetHeader]="widgetCollapsed ? 'hide' : 'show'"
    (click)="toggleWidget()"
  >
    <h4>{{ 'Map Legend' | translate }}</h4>
  </div>
  <div
    class="legendWrapper"
    [@openCloseWidgetContent]="widgetCollapsed ? 'hide' : 'show'"
  >
    <app-selector
      *ngIf="showDensity"
      [options]="modeOptions"
      [autoClose]="true"
      [selected]="selectedMode"
      (onSelectOption)="changeMode($event)"
    ></app-selector>
    <h5>
      {{ title | translate
      }}<span *ngIf="titleExtra"> ({{ titleExtra | translate }})</span>
    </h5>
    <div class="legend" *ngIf="type === 'ramp'">
      <div class="labels">
        <ng-container *ngIf="labels">
          <span *ngFor="let label of labels">{{
            parse(label) | translate
          }}</span>
        </ng-container>
      </div>
      <div class="colors">
        <div
          class="elem color1"
          *ngFor="let color of colors"
          [style.background-color]="color"
        ></div>
      </div>
    </div>
    <div class="legend line" *ngIf="type === 'line'">
      <div class="labels">
        <span>{{ labels ? (parse(labels[0]) | translate) : '-' }}</span>
      </div>
      <div class="line">
        <div class="low"></div>
        <div class="high"></div>
      </div>
      <div class="labels">
        <span>{{ labels ? (parse(labels[1]) | translate) : '-' }}</span>
      </div>
    </div>
    <p>{{ subtitle | translate }}</p>
  </div>
</div>
